"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseSchema = exports.QuerySchema = exports.method = exports.path = void 0;
exports.parseQuery = parseQuery;
exports.parseResponse = parseResponse;
const zod_1 = require("zod");
const common_1 = require("../../common");
const lingo2_models_1 = require("lingo2-models");
const common_2 = require("./common");
// Здесь указываем path относительно основного роута
// например `${config.http.webUrl}` `${config.http.panelUrl}` `${config.http.backUrl}`
/** Относительно `${config.http.*}` */
exports.path = 'user-profile/schools';
exports.method = common_1.HttpMethod.GET;
// #region Request
// Тело запроса. Optional
// export const BodySchema = z.object({});
// export type Body = z.infer<typeof BodySchema>;
// export function parseBody(values: Body) {
//   return BodySchema.parse(values);
// }
// Параметры запроса. Optional
// export const ParamsSchema = z.object({});
// export type Params = z.infer<typeof ParamsSchema>;
// export function parseParams(values: Params) {
//   return ParamsSchema.parse(values);
// }
// Query параметры запроса. Optional
exports.QuerySchema = zod_1.z.object({
  authorId: zod_1.z.string().uuid(),
  page: zod_1.z.coerce.number().min(1),
  pageSize: zod_1.z.coerce.number().min(1)
});
function parseQuery(values) {
  return exports.QuerySchema.parse(values);
}
// #endregion
// #region Response
const ParticipantSchema = zod_1.z.object({
  accountId: zod_1.z.string(),
  avatarId: zod_1.z.string(),
  fullName: zod_1.z.string()
});
exports.ResponseSchema = zod_1.z.object({
  data: zod_1.z.array(zod_1.z.object({
    _id: zod_1.z.string(),
    slug: zod_1.z.string(),
    title: zod_1.z.string(),
    subDescription: zod_1.z.string(),
    description: zod_1.z.string(),
    headCoverId: zod_1.z.string().uuid(),
    coverId: zod_1.z.string().uuid(),
    status: zod_1.z.nativeEnum(lingo2_models_1.ESchoolStatus),
    subjects: zod_1.z.array(zod_1.z.object({
      subjectId: zod_1.z.number(),
      subjectName: zod_1.z.string()
    })),
    numberOfStudent: zod_1.z.number(),
    owners: zod_1.z.array(ParticipantSchema),
    teachers: zod_1.z.array(ParticipantSchema),
    students: zod_1.z.array(ParticipantSchema),
    visitInfo: zod_1.z.object({
      isOwner: zod_1.z.boolean(),
      isTeacher: zod_1.z.boolean(),
      isStudent: zod_1.z.boolean(),
      isBookmarked: zod_1.z.boolean()
    })
  })),
  pagination: common_2.PaginationSchema
});
function parseResponse(values) {
  return exports.ResponseSchema.parse(values);
}
// #endregion
